<template>
	<div class="payDetails">
		<div class="filter-container" style="position: relative;padding-right: 200px;">
			<div class="filter-item">
				<label class="label" style="width: 75px;text-align: right;">交易时间:</label>
				<el-date-picker v-model="dateRange" type="datetimerange" format="yyyy-MM-dd HH:mm" :clearable="false"  :default-time="['00:00:00','23:59:59']"
					value-format="yyyy-MM-dd HH:mm" align="right" unlink-panels range-separator="至"
					start-placeholder="开始日期" end-placeholder="结束日期">
				</el-date-picker>
			</div>
			<div class="help-box">
				<el-popover
					placement="bottom-end"
					title=""
					width="430"
					trigger="click"
					content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。">
					<div class="help-content">
						<div>①  自营销售额：支付时间在筛选时间范围内，且由推手本人自购或分享链接给客户购买产生的订单，这类订单的实付金额总和，不含支付的运费</div>
						<div>②  自营退款额：退款成功时间在筛选时间范围内，且由推手本人自购或分享链接给客户购买产生的订单，这类退款单的退款金额总和，不含退回的运费</div>
						<div>③  自营成交额：=自营销售额-自营退款额</div>
						<div>④  团队销售额：=推手自营销售额+推手团队所有下级自营销售额</div>
						<div>⑤  团队退款额：=推手自营退款额+推手团队所有下级自营退款额</div>
						<div>⑥  团队成交额：=团队销售额-团队退款额</div>
					</div>
					<div class="help" slot="reference"><i class="el-icon-warning-outline"></i><span class="text">销售数据统计说明</span></div>
				</el-popover>
			</div>
			
		</div>
		<div class="filter-container">
			<div class="filter-item" style="vertical-align: top;">
				<label class="label" style="width: 75px;display: inline-block;text-align: right;">关键字:</label>
				<el-select v-model="KeyWordsType" placeholder="请选择" style="width: 160px;margin-right: 10px;">
					<el-option :value="0" label="推手"></el-option>
					<el-option :value="1" label="推手上级"></el-option>
					<el-option :value="3" label="最高级别推手"></el-option>
				</el-select>
				<el-input @keyup.enter.native="doorListFilter" v-model="KeyWords" placeholder="推手姓名、手机号、微信昵称"
					style="width: 250px;" clearable></el-input>
			</div>

			<div class="filter-item" style="vertical-align: top;">
				<label class="label">推手级别:</label>
				<el-select v-model="DistibutorRoleId">
					<el-option label="全部" :value="null"></el-option>
					<el-option v-for="item in gradeOptions" :key="item.AgentRoleId" :label="item.AgentRoleName"
						:value="item.AgentRoleId"></el-option>
				</el-select>
			</div>

			<div class="filter-item">
				<el-button type="primary" style="width:90px;" @click="doorListFilter">查询</el-button>

				<buttonPermissions :datas="'agentSalesDetailExport'">
					<el-button style="margin-left:20px;width:90px;" @click="exportFun">导出</el-button>
				</buttonPermissions>
			</div>
		</div>
		<!-- 订单表格 -->
		<div class="table-container">
			<el-table :data="groupData" v-loading="loading">
				<el-table-column label="推手信息" :show-overflow-tooltip="true" width="220">
					<template slot-scope="scope">
						<div class="ellipsis-one">{{ scope.row.Name || scope.row.WxNickname }}</div>
						<div>{{ scope.row.Phone }}</div>
					</template>
				</el-table-column>
				<el-table-column prop="AgentRoleName" :show-overflow-tooltip="true" label="当前级别"></el-table-column>
				<el-table-column prop="SelfSellMoney" label="自营销售额(元)"></el-table-column>
				<el-table-column prop="SelfRefundMoney" label="自营退款额(元)"></el-table-column>
				<el-table-column prop="SelfDealMoney" label="自营成交额(元)"></el-table-column>
				<el-table-column prop="TeamSellMoney" label="团队销售额(元)"></el-table-column>
				<el-table-column prop="TeamRefundMoney" label="团队退款额(元)"></el-table-column>
				<el-table-column prop="TeamDealMoney" label="团队成交额(元)"></el-table-column>

				<el-table-column prop="" label="操作" width="100">
					<template slot-scope="scope">
						<el-button @click="handleToDetails(scope.row)" type="text">销售明细</el-button>
					</template>
				</el-table-column>

			</el-table>
			<div style="text-align: right;">
				<el-pagination v-if="Total" style="margin:20px 0" @size-change="handleSizeChange"
					@current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 30, 40, 50]"
					:page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
					:total="Total"></el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
import { AgentfilterBoxList } from "@/api/TurnTomySelf.js";
import apiList from "@/api/other";
import config from "@/config/index";
import buttonPermissions from '@/components/buttonPermissions';
export default {
	components: {
		buttonPermissions
	},
	data() {
		return {
			MemberId: null,
			KeyWordsType: 0,
			KeyWords: "",
			DistibutorRoleId: null,
			StartTime: "",
			EndTime: "",
			OrderFrom: 0,
			OrderFromlist: [
				{
					value: 0,
					label: '小程序商城订单'
				}, {
					value: 1,
					label: '视频号小店订单'
				},
			],
			loading: false,
			listStateList: [
				{
					id: '0',
					value: "销售单明细"
				},
				{
					id: 1,
					value: "退款单明细"
				}
			],
			gradeOptions: [],
			listState: "0",
			currentPage: 1,
			pageSize: 20,
			Total: 0,
			groupData: [],
			exportUrl: config.EXPORT_URL,
			goUrls: config.GO_URL,
			SellTotal: 0,
			RefundTotal: 0,
			dateRange: []
		};
	},
	created() {
		this.getAuthList();
	},
	beforeMount() {
		this.initTime();
		this.KeyWords = this.$route.query.KeyWords ? this.$route.query.KeyWords : "";
		if (this.$route.query.KeyWords) {
			this.StartTime = this.$route.query.starTime;
			this.EndTime = this.$route.query.endTime;
			this.listState = this.$route.query.listState + '';
			this.OrderFrom = Number(this.$route.query.OrderFrom)
		}

		this.getList();
	},
	methods: {
		async getAuthList() {
			try {
				let result = await AgentfilterBoxList();
				this.gradeOptions = result.Result;
			} catch (e) {
			}
		},
		//跳转到订单详情
		handleToDetails(row) {
			let headsUrls = process.env.NODE_ENV == "production" ? "index.html#" : "";
			let url = this.goUrls + headsUrls + '/agent/salesDetail?start=' + this.dateRange[0]+'&end='+this.dateRange[1]+'&phone='+row.Phone;
			window.open(url);
		},
		async getList() {
			try {
				this.loading = true;
				let data = {
					KeyWords: this.KeyWords,
					KeyWordsType: this.KeyWordsType,
					StartTime: this.dateRange[0],
					EndTime: this.dateRange[1],
					AgentRoleId: this.DistibutorRoleId,
					Skip: (this.currentPage - 1) * this.pageSize, // 略过数据
					Take: this.pageSize, // 取的数据
				};
				let result = await apiList.salesDataStatistics(data);
				this.Total = result.Result.Total;
				this.groupData = result.Result.Results || [];
			} catch (e) {
				console.log(e);
			} finally {
				this.loading = false;
			}
		},
		filterFun() {
			this.MemberId = null;
			// this.KeyWordsType = 0;
			// this.KeyWords = "";
			this.DistibutorRoleId = null;
			this.OrderFrom = 0
			this.currentPage = 1;
			this.pageSize = 20;
			this.getList();
		},
		initTime() {
			let date = new Date();
			let year = date.getFullYear();
			let month = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1);
			let day = date.getDate() > 9 ? date.getDate() : "0" + date.getDate();
			let hour = date.getHours() > 9 ? date.getHours() : "0" + date.getHours();
			let minute = date.getMinutes() > 9 ? date.getMinutes() : "0" + date.getMinutes();
			let second = date.getSeconds() > 9 ? date.getSeconds() : "0" + date.getSeconds();
			this.StartTime = year + "-" + month + "-" + "01" + " " + "00:00";
			this.EndTime = year + "-" + month + "-" + day + " " + `${hour}:${minute}`;
			this.dateRange = [this.StartTime, this.EndTime];
			console.log(this.dateRange)
		},
		// 查询
		doorListFilter() {
			this.currentPage = 1;
			this.getList();
		},
		exportFun() {
			let api = "/pc/agent/salesDataStatisticsExport";
			let url =
				this.exportUrl + api + "?" +
				"KeyWordsType=" + this.KeyWordsType +
				"&KeyWords=" + this.KeyWords +
				"&StartTime=" + this.dateRange[0] +
				"&EndTime=" + this.dateRange[1] +
				"&AgentRoleId=" + (this.DistibutorRoleId ? this.DistibutorRoleId : "");
			window.open(url);
		},
		handleSizeChange(val) {
			this.pageSize = val;
			this.getList();
		},

		handleCurrentChange(val) {
			this.currentPage = val;
			this.getList();
		}
	}
};
</script>

<style lang="less" scoped>

.ellipsis-one{
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.help-box{
	position: absolute;
	right: 16px;
	top: 10px;
}
.help-content{
	font-weight: 500;
	font-size: 12px;
	color: #606266;
	line-height: 20px;

	div{
		margin-bottom: 15px;

		&:last-child{
			margin-bottom: 0;
		}
	}
}
.help{
	cursor: pointer;
	display: flex;
	align-items: center;

	.text{
		font-size: 14px;
		color: #606266;
		line-height: 20px;
		text-decoration: underline;
		margin-left: 4px;
	}
}

.payDetails {
	background: #fff;
	padding: 15px;
}
</style>
